var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    xmlnsv: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.622l3.637.052c1.025.046 1.975.252 2.706.983s.937 1.682.983 2.706L16.378 9l-.052 3.637c-.047 1.025-.252 1.975-.983 2.706s-1.681.937-2.706.983L9 16.378c-2.403 0-2.688-.009-3.637-.052-1.024-.047-1.975-.252-2.706-.983s-.937-1.681-.983-2.706L1.622 9l.052-3.637c.046-1.024.252-1.975.983-2.706s1.682-.937 2.706-.983L9 1.622zM9 0L5.289.054C3.827.121 2.542.479 1.511 1.511S.121 3.827.054 5.289L0 9l.054 3.711c.067 1.463.425 2.747 1.457 3.778s2.316 1.39 3.778 1.457L9 18l3.711-.054c1.463-.067 2.747-.425 3.778-1.457s1.39-2.316 1.457-3.778L18 9l-.054-3.711c-.067-1.462-.425-2.747-1.457-3.778S14.174.121 12.711.054L9 0zm0 4.378c-2.552 0-4.622 2.07-4.622 4.622S6.448 13.621 9 13.621 13.622 11.552 13.622 9 11.552 4.378 9 4.378zM9 12a3 3 0 0 1 0-6 3 3 0 1 1 0 6zm4.805-6.725a1.08 1.08 0 1 0 0-2.16 1.08 1.08 0 1 0 0 2.16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.097d3a01500963c687c3f44c169902cc.svg";
export { ForwardRef as ReactComponent };